import React from 'react';
import UserLink from './UserLink';

const FollowerList = (props) => {
    const { followers = [], usersFollowed = [] } = props;

    return (
        <ul className="list-group p-3">
            <li className="list-group-item">
                <p className="followlist-header mb-1">
                    Followers
                    <span className="badge bg-secondary rounded-pill">
                        {followers.length}
                    </span>
                </p>
                {followers.length > 0 ? (
                    followers.map((follower) => (
                        <UserLink
                            firstName={follower.follower.first_name}
                            lastName={follower.follower.last_name}
                            userName={follower.follower.username}
                            key={follower.follower.id}
                        />
                    ))
                ) : (
                    <p>No followers yet.</p>
                )}
            </li>
            <li className="list-group-item">
                <p className="followlist-header mb-1">
                    Following
                    <span className="badge bg-secondary rounded-pill">
                        {usersFollowed.length}
                    </span>
                </p>
                {usersFollowed.length > 0 ? (
                    usersFollowed.map((userFollowed) => (
                        <UserLink
                            firstName={userFollowed.user.first_name}
                            lastName={userFollowed.user.last_name}
                            userName={userFollowed.user.username}
                            key={userFollowed.user.id}
                        />
                    ))
                ) : (
                    <p>You're not following anyone yet.</p>
                )}
            </li>
        </ul>
    );
};

export default FollowerList;
